import { StateParams } from "@uirouter/angularjs";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../../machines/shared/components/views/machines/detail/tabs";
import { vsComponentName as FormViewComponentName } from "../../../records/forms/formView";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { resolveMealLogForm } from "../entryDetail/resolveMealLogForm";
import { vsComponentName as mealLogListComponentName } from "./component";
import { ServiceResponse } from "../../../records/server/query";
import { Record } from "../../../records/server/crud";

configMealLogMachineTab.$inject = [MachineDetailTabsProviderName];
export function configMealLogMachineTab(
  machineDetailTabsProvider: MachineDetailTabsProvider
) {
  machineDetailTabsProvider.addElement({
    displayName: "MEAL Log",
    uiSrefFragment: "mealLog",
    requiredPermission: "mealLogView",
    id: "mealLog",
    stateDefinition: {
      url: "/mealLog",
      component: mealLogListComponentName,
      bindings: {},
    },
    children: [
      {
        displayName: "Edit",
        id: "edit",
        requiredPermission: "mealLogUpdate",
        uiSrefFragment: "edit",
        stateDefinition: {
          url: "/{mealLogId:int}/edit",
          views: {
            "@^.^": {
              component: FormViewComponentName,
            },
          },
          resolve: resolveMealLogForm(
            "Edit MEAL Log",
            [
              ServerUtilityName,
              "$stateParams",
              (serverUtility: ServerUtility, $stateParams: StateParams) =>
                serverUtility
                  .getById<ServiceResponse<Record>>({
                    url: "/api/machines/mealLog",
                    id: $stateParams.mealLogId,
                  })
                  .then((r) => r.Result),
            ],
            "^"
          ),
        },
      },
      {
        displayName: "Create",
        id: "create",
        requiredPermission: "mealLogAdd",
        uiSrefFragment: "add",
        stateDefinition: {
          views: {
            "@^.^": {
              component: FormViewComponentName,
            },
          },
          resolve: resolveMealLogForm(
            "Create MEAL Log",
            [
              "machine",
              (machine: Record) => {
                return {
                  MachineId: machine.Id,
                };
              },
            ],
            "^"
          ),
        },
      },
    ],
  });
}
